import React, { useState } from 'react'
import InputGroup from './EmailInputGroup.jsx'
import { postJsonDataBlankResponse } from '../../global/data/service.js'

export default function EmailContactForm(props) {
  const { service, onSubmitted, showError } = props

  const [formData, setFormData] = useState({
    fullName: null,
    phoneNumber: null,
    emailAddress: null,
    messageText: null,
  })

  const [formValidation, setFormValidation] = useState({
    fullName: {
      error: false,
      errorMessage: 'Please enter your first name and last name',
    },
    phoneNumber: {
      error: false,
      errorMessage: 'Please enter your phone number',
    },
    emailAddress: {
      error: false,
      errorMessage: 'Please enter a valid email address',
    },
    messageText: {
      error: false,
      errorMessage: 'Please enter a message',
    },
  })

  const createEmailPayload = () => {
    return {
      type: 'email',
      data: {
        from: formData.emailAddress,
        to: [service.recipientEmail],
        subject: service.subject,
        body: `From: ${formData.fullName} <br/> Phone: ${formData.phoneNumber} <br/> Message: ${formData.messageText}`,
      },
    }
  }

  // handle formData update
  const handleFormInput = (event) => {
    let _formData = { ...formData }

    _formData[event.target.name] = event.target.value

    let _formValidation = { ...formValidation }
    _formValidation[event.target.name].error = false

    setFormData(_formData)
    setFormValidation(_formValidation)
  }

  // handle form validation
  const handleFormValidation = () => {
    let _formValidation = { ...formValidation }

    if (!formData.fullName) {
      _formValidation.fullName.error = true
    }

    if (!formData.phoneNumber) {
      _formValidation.phoneNumber.error = true
    }

    if (!formData.emailAddress || !formData.emailAddress.includes('@')) {
      _formValidation.emailAddress.error = true
    }

    if (!formData.messageText) {
      _formValidation.messageText.error = true
    }

    return _formValidation
  }

  const handleSubmitForm = async (event) => {
    event.preventDefault()

    const _formValidation = handleFormValidation()

    const isError = Object.entries(_formValidation).find(
      ([, value]) => value.error
    )

    if (!isError) {
      const emailPayLoad = createEmailPayload()

      const url = '/api/email'

      const response = await postJsonDataBlankResponse(url, emailPayLoad)

      if (!response.ok) {
        showError && showError()
      }

      onSubmitted && onSubmitted()
    } else {
      setFormValidation(_formValidation)
    }
  }

  const handleCancelEmail = () => {
    window.history.back()
  }

  return (
    <>
      <div className="u-sizeConstrained u-marginTop12gu">
        <hr className="Rule u-textColorBrand" />
        <div className="Card u-marginBottom4gu u-padding0">
          <div className="Card-body">
            <div className="page-header-title Content">
              <h2 className="u-marginBottom3gu" role="heading">
                {service.type}
              </h2>
              {service.subHeading && (
                <p className="u-marginBottom3gu">
                  {service.subHeading}
                  <sup>1</sup>
                </p>
              )}
              <p>
                Please do not include personal information such as account
                numbers, Social Security numbers or taxpayer identification
                numbers in your email.
              </p>
            </div>
            <div className="Grid Grid--alignMiddle u-marginTop8gu">
              <div className="Content u-sizeFill">
                <p className="u-textBold">Contact Information</p>
              </div>
              <div className="u-sizeFit">
                <p className="u-textItalic u-textSecondary">
                  <span
                    className="required u-textColorAlert"
                    aria-required="true"
                  >
                    *{' '}
                  </span>
                  Required Information
                </p>
              </div>
            </div>
            <hr className="Rule Rule--thin" />
            <div className="contact-us-email-container u-marginBottom4gu">
              <div className="row">
                <section id="contact-us-by-email" className="box">
                  <form
                    id="contact-us-by-email-form"
                    name="contact-us-by-email-form"
                    method="post"
                    action="#"
                    role="form"
                    className="form-horizontal cart-checkout-form clearfix"
                  >
                    <InputGroup
                      handleFormInput={handleFormInput}
                      fieldName="fullName"
                      label="Full Name"
                      formData={formData}
                      formValidation={formValidation}
                      maxLength="100"
                      type="text"
                    />
                    <InputGroup
                      handleFormInput={handleFormInput}
                      fieldName="phoneNumber"
                      label="Phone Number"
                      formData={formData}
                      formValidation={formValidation}
                      maxLength="20"
                      type="tel"
                    />
                    <InputGroup
                      handleFormInput={handleFormInput}
                      fieldName="emailAddress"
                      label="Email Address"
                      formData={formData}
                      formValidation={formValidation}
                      maxLength="50"
                      type="text"
                    />
                    <InputGroup
                      handleFormInput={handleFormInput}
                      fieldName="messageText"
                      label="Message"
                      formData={formData}
                      formValidation={formValidation}
                      maxLength="500"
                      rows="10"
                      textAreaType={true}
                    />
                    <div className="Grid">
                      <div className="u-size9of12 u-md-before3of12 u-lg-before3of12 u-sm-sizeFull">
                        <div className="Grid Grid--withGutter">
                          <div className="u-sm-size6of12 u-md-before2of12 u-md-size5of12 u-lg-before4of12 u-lg-size4of12">
                            <button
                              className="Button Button--secondary Button--block u-textNoTransform"
                              onClick={handleCancelEmail}
                            >
                              Cancel
                            </button>
                          </div>
                          <div className="u-sm-size6of12 u-md-size5of12 u-lg-size4of12">
                            <button
                              className="Button Button--primary Button--block cti-submit-email-form-button u-textNoTransform"
                              onClick={handleSubmitForm}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>

      {service.disclosure && (
        <div className="u-sizeConstrained u-marginTop12gu">
          <hr className="Rule u-textColorBrand" />
          <div className="Card u-marginBottom4gu u-padding0">
            <div className="Card-body">
              <div className="page-header-title Content">
                <h2 role="heading">Disclosures</h2>
                <p className="u-marginVert3gu">
                  <sup>1</sup> {service.disclosure}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
